exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.chain-logo[data-v-6f928759] {\n  max-width: 200px;\n  max-height: 200px;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n.right-align[data-v-6f928759] {\n  text-align: right;\n}\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/views/chain/chain-info.vue"],"names":[],"mappings":";AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;CAAE;AAEvB;EACE,kBAAkB;CAAE","file":"chain-info.vue","sourcesContent":[".chain-logo {\n  max-width: 200px;\n  max-height: 200px;\n  vertical-align: middle;\n  margin-right: 10px; }\n\n.right-align {\n  text-align: right; }\n"],"sourceRoot":""}]);

// exports
